import { LEGAL_OPERATOR } from '@/content/legal/operator'

export const PRIVACY_POLICY_DEVFRONT2_EDITED_AT = '1 июня 2026 г.'

export const PRIVACY_POLICY_DEVFRONT2_SECTIONS = [
  {
    title: '1. Общие положения',
    paragraphs: [
      `Настоящая Политика определяет порядок обработки персональных данных посетителей маркетингового сайта ${LEGAL_OPERATOR.brandName}.`,
      `Оператор персональных данных: ${LEGAL_OPERATOR.fullName}, ИНН ${LEGAL_OPERATOR.inn}, ОГРНИП ${LEGAL_OPERATOR.ogrnip}.`,
      'Политика подготовлена в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ «О персональных данных».',
    ],
  },
  {
    title: '2. Какие данные обрабатываются',
    list: [
      'контактные данные, которые посетитель вводит в форме заявки: имя, телефон, e-mail, компания;',
      'содержимое сообщения и ответы в форме-опросе на сайте;',
      'технические данные: IP-адрес, cookie, user-agent, дата и время визита.',
    ],
  },
  {
    title: '3. Цели обработки данных',
    list: [
      'обработка заявки и обратная связь с посетителем;',
      'демонстрация возможностей сервиса и консультация по подключению;',
      'улучшение работы сайта и аналитика качества пользовательского пути;',
      'выполнение требований законодательства Российской Федерации.',
    ],
  },
  {
    title: '4. Правовые основания обработки',
    list: [
      'согласие субъекта персональных данных;',
      'необходимость обработки данных для ответа на обращение посетителя;',
      'исполнение требований законодательства Российской Федерации.',
    ],
  },
  {
    title: '5. Передача данных третьим лицам',
    paragraphs: [
      'Передача данных допускается только в объеме, необходимом для работы сайта и коммуникации с посетителем.',
    ],
    list: [
      'провайдеры хостинга и инфраструктуры;',
      'сервисы корпоративной почты и CRM для обработки заявок;',
      'уполномоченные государственные органы в случаях, предусмотренных законом.',
    ],
  },
  {
    title: '6. Сроки хранения',
    paragraphs: [
      'Персональные данные хранятся не дольше, чем это требуется для целей обработки, либо до отзыва согласия субъектом данных, если иное не предусмотрено законом.',
    ],
  },
  {
    title: '7. Права субъекта персональных данных',
    list: [
      'получать сведения об обработке своих данных;',
      'требовать уточнения, блокирования или удаления данных;',
      'отозвать согласие на обработку персональных данных;',
      'обжаловать действия оператора в Роскомнадзор или суд.',
    ],
  },
  {
    title: '8. Cookie и технические файлы',
    paragraphs: [
      'Сайт использует cookie и аналогичные технологии для стабильной работы интерфейса и аналитики.',
      'Отключение cookie может повлиять на корректность отдельных функций сайта.',
    ],
  },
  {
    title: '9. Контакты по вопросам ПДн',
    paragraphs: [
      `По вопросам обработки персональных данных обращайтесь на ${LEGAL_OPERATOR.email} или по телефону ${LEGAL_OPERATOR.phone}.`,
    ],
  },
]
